package org.abhranilnxt.portfolio.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.icons.fa.FaDiscord
import com.varabyte.kobweb.silk.components.icons.fa.FaGithub
import com.varabyte.kobweb.silk.components.icons.fa.FaInstagram
import com.varabyte.kobweb.silk.components.icons.fa.FaLinkedin
import com.varabyte.kobweb.silk.components.icons.fa.FaSquareSteam
import com.varabyte.kobweb.silk.components.icons.fa.FaSteam
import com.varabyte.kobweb.silk.components.icons.fa.FaSteamSymbol
import com.varabyte.kobweb.silk.components.icons.fa.FaTwitter
import com.varabyte.kobweb.silk.components.icons.fa.FaYoutube
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import org.abhranilnxt.portfolio.styles.SocialLinkStyle
import org.jetbrains.compose.web.css.px

@Composable
fun SocialBar(row: Boolean = false) {
    if(row) {
        Row(
            modifier = Modifier
                .margin(top = 25.px)
                .padding(leftRight = 20.px)
                .minHeight(40.px)
                .borderRadius(r = 20.px)
                .backgroundColor(Colors.White),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {
            SocialLinks(row = true)
        }
    }
    else {
        Column(
            modifier = Modifier
                .margin(right = 25.px)
                .padding(topBottom = 20.px)
                .minWidth(40.px)
                .borderRadius(r = 20.px)
                .backgroundColor(Colors.White),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SocialLinks()
        }
    }
}

@Composable
private fun SocialLinks(row: Boolean = false) {
    Link(
        path = "https://github.com/AbhranilNXT",
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        FaGithub(
            modifier = SocialLinkStyle
                .toModifier()
                .margin(bottom = if(row) 0.px else 30.px,
                    right = if(row) 30.px else 0.px),
            size = IconSize.LG
        )
    }
    Link(
        path = "https://www.linkedin.com/in/abhranildasgupta/",
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        FaLinkedin(
            modifier = SocialLinkStyle
            .toModifier()
            .margin(bottom = if(row) 0.px else 30.px,
                right = if(row) 30.px else 0.px),
            size = IconSize.LG
        )
    }
    Link(
        path = "https://steamcommunity.com/id/AbhranilNXT/",
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        FaSquareSteam(
            modifier = SocialLinkStyle
                .toModifier()
                .margin(bottom = if(row) 0.px else 30.px,
                    right = if(row) 30.px else 0.px),
            size = IconSize.LG
        )
    }
    Link(
        path = "https://twitter.com/abhranilnxt",
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        FaTwitter(
            modifier = SocialLinkStyle
            .toModifier()
            .margin(bottom = if(row) 0.px else 30.px,
                right = if(row) 30.px else 0.px),
            size = IconSize.LG
        )
    }
    Link(
        path = "https://www.instagram.com/abhranil_nxt",
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        FaInstagram(
            modifier = SocialLinkStyle
                .toModifier()
                .margin(bottom = if(row) 0.px else 30.px,
                    right = if(row) 30.px else 0.px),
            size = IconSize.LG
        )
    }
    Link(
        path = "https://discordapp.com/users/709861754502643728",
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        FaDiscord(
            modifier = SocialLinkStyle
                .toModifier()
                .margin(bottom = if(row) 0.px else 30.px,
                    right = if(row) 30.px else 0.px),
            size = IconSize.LG
        )
    }
    Link(
        path = "https://www.youtube.com/@abhranilnxt1782",
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        FaYoutube(
            modifier = SocialLinkStyle
            .toModifier(),
            size = IconSize.LG
        )
    }
}